/* eslint-disable camelcase, no-undef */
// Must be imported before anything else in an entry point that lazy-loads
// chunks. webpack 4 has no `publicPath: 'auto'`, and the static value in
// webpack.config.js (`/javascripts/`) is wrong in every environment we
// actually deploy to: TYPO3 serves the bundle from a hashed
// /_assets/<hash>/dist/ path and the Fractal styleguide from
// /hida/styleguide/. Deriving the dist root from this script's own URL is
// correct in all of them.
//
// main.js is included as a plain, non-async footer <script>
// (page.typoscript includeJSFooter), so document.currentScript is reliable
// here. The guard keeps the configured value as a fallback if it ever
// isn't (e.g. some future async include).
if (document.currentScript && document.currentScript.src) {
  // …/dist/javascripts/main.js -> …/dist/
  __webpack_public_path__ = document.currentScript.src.replace(/javascripts\/[^/]*$/, '');
}
